import { render } from "./idAuth.vue?vue&type=template&id=f0a5c0fa&scoped=true"
import script from "./idAuth.vue?vue&type=script&lang=js"
export * from "./idAuth.vue?vue&type=script&lang=js"

import "./idAuth.vue?vue&type=style&index=0&id=f0a5c0fa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0a5c0fa"]])

export default __exports__